import styled from 'styled-components';

export const LoadingIcon = styled.img`
  animation: rotation 1s infinite linear;

  @keyframes rotation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  height: 60px;
  justify-content: flex-end;
  padding: 0 0 0 24px;
  background: ${(props) => props.theme.colors?.greys.lightest};
  z-index: 200;
`;
